import type { AccountSource } from '@/api/generated/model';
import { StatusBadge } from '@/components/ui/status-badge';
import { useLanguage } from '@/i18n/language-hooks';

interface AccountSourceBadgeProps {
  source: AccountSource;
  className?: string;
}

export function AccountSourceBadge({ source, className }: AccountSourceBadgeProps) {
  const { t } = useLanguage();
  const tone = source === 'integration' ? 'info' : 'muted';
  return (
    <StatusBadge tone={tone} size='sm' className={className}>
      {t(`accounts.source.${source}`)}
    </StatusBadge>
  );
}
